
const Background = require("./background");
const {Point} = require("./point");
const {PointImage} = require("./point-image");
const {Text} = require("./text");
module.exports = {
    /**
     * Отрисовка объектов слайда
     */
    drawObjects(slide) {
        const data = JSON.parse(slide.data);
        Background.set(data.bgImage, data.bgVideo, data.bgVideoUrl, data.bgVideoSlideId);
        const layer = window.STAGE.getLayers()[1];
        if (data.points) {
            data.points.forEach(pointData => {
                const point = new Point(layer, {
                    x: pointData.x,
                    y: pointData.y,
                    icon: pointData.text,
                    color: pointData.color,
                    bg: pointData.background,
                    size: 25,
                    offsetCursor: 0,
                    url: pointData.url,
                    slideId: pointData.slideId
                });

                point.group.x(pointData.groupX)
                point.group.y(pointData.groupY)
                Point.setRotate(point.group, pointData.rotation);
                Point.setScale(point.group, pointData.scaleX, pointData.scaleY);
            });
        }


        if (data.texts) {
            data.texts.forEach(textData => {
                const text = new Text(layer, {
                    x: textData.x,
                    y: textData.y,
                    text: textData.text,
                    color: textData.color,
                    fontFamily: textData.fontFamily,
                    fontStyle: textData.fontStyle,
                    textDecoration: textData.textDecoration,
                    size: textData.size,
                    offsetCursor: 0,
                    offsetX: 0,
                    offsetY: 0,
                    url: textData.url,
                    slideId: textData.slideId
                });

                text.group.x(textData.groupX)
                text.group.y(textData.groupY)
                Text.setRotate(text.group, textData.rotation);
                Text.setScale(text.group, textData.scaleX, textData.scaleY);
            });
        }


        if (data.pointImages) {
            data.pointImages.forEach(pointData => {
                console.log(pointData)
                const image = new PointImage(layer, {
                    x: pointData.x,
                    y: pointData.y,
                    path: pointData.path,
                    offsetCursor: 0,
                    url: pointData.url,
                    slideId: pointData.slideId,
                    id: pointData.id
                });

                image.group.x(pointData.groupX)
                image.group.y(pointData.groupY)
                PointImage.setRotate(image.group, pointData.rotation);
                PointImage.setScale(image.group, pointData.scaleX, pointData.scaleY);
            });
        }


       // window.UpdateLayer.start();
    },

    initKonva() {
        console.log('%cИнициализация KONVA.JS', 'color: green');
        const stage = new Konva.Stage({
            container: 'konva-container',
            width: window.MAIN_WIDTH,
            height: window.MAIN_HEIGHT,
        });

        window.STAGE = stage;

        stage.container().style.outline = 'NONE';


        const layerBG = new Konva.Layer({name: 'bg-layer'});
        stage.add(layerBG);
        layerBG.moveToBottom();

        const layer = new Konva.Layer({name: 'main'});

        stage.add(layer);

        window.UpdateLayer = new Konva.Animation(function () {}, layerBG);

        // console.log(stage.getLayers());
        //
        // const cursor = new Cursor(); // Курсор
        //
        window.addEventListener('resize', () => {
            this.resize(window.document.querySelector('#konva-container'))
        });
        this.resize(window.document.querySelector('#konva-container'))


        //
        // stage.on('click touchstart', (e) => {
        //     console.log('click');
        //     const group: Group = e.target.getParent();
        //     if (group && group.nodeType !== 'Layer') {
        //         return;
        //     }
        //
        //     if (this.toolsService.isPoint()) {
        //         const pos: any = stage.getPointerPosition();
        //         pos.x = pos.x / stage.scaleX();
        //         pos.y = pos.y / stage.scaleY();
        //         const point: Point = new Point(layer, {
        //             x: pos.x,
        //             y: pos.y,
        //             icon: '',
        //             color: this.pointService.color,
        //             bg: this.pointService.backgroundColor,
        //             size: 25,
        //             offsetCursor: 15,
        //             url: this.pointService.url,
        //             slideId: this.pointService.slideId
        //         });
        //
        //         // После отрисовки сбросить индивидуальные поля (напр. ссылку и slideId)
        //         this.pointService.resetFields()
        //     }
        // });
        //
        // stage.on('contextmenu', (e) => {
        //     e.evt.preventDefault();
        //     const group: Group = e.target.getParent();
        //     if (group && group.nodeType !== 'Layer') {
        //         console.log('click', group)
        //         //this.toolService.setTool('cursor');
        //         return;
        //     }
        //
        // });
        //
        // EditorService.resize(this.konvaContainer.nativeElement);
    },

    /**
     * Очистка контейнера
     */
    clearContainer() {
        Background.clearLayer();

        // Находим все группы
        STAGE.find('.group-point, .group-text, .group-image').forEach(group => {
            group.destroy();
        });
        STAGE.container().style.cursor = 'default';
    },

    resize(container) {
        console.log('%cResize', 'color: orange', container.offsetWidth, container.offsetHeight);
        const containerWidth = container.offsetWidth;

        let scale = containerWidth / window.MAIN_WIDTH;
        // Если больше 1, то используются дефолтные размеры MAIN_WIDTH и MAIN_HEIGHT
        // if (scale > 1) {
        //     scale = 1;
        // }

        window.STAGE.width(window.MAIN_WIDTH * scale);
        window.STAGE.height(window.MAIN_HEIGHT * scale);
        window.STAGE.scale({x: scale, y: scale});

    },
    openSlide(slideId) {
        window.STAGE.container().classList.add('fade');
        setTimeout(() => {
            const slide = project.slides.find(el => el.id === slideId);
            if (slide) {
                this.clearContainer();
                this.drawObjects(slide);
            } else {
                console.log('Slide not found')
            }
            window.STAGE.container().classList.remove('fade');
        }, 300);
        module.exports.pushStat(slideId)
    },

    pushStat(slideId) {
        axios({
            method: 'get',
            url: 'https://' + window.location.host + '/api/stats/push',
            params: {slideId: slideId},
        })
            .then(function (response) {
                console.log(response)
            });
    }
}
